module.exports = __webpack_public_path__ + "img/6.72b1418d.png";